module.exports = __webpack_public_path__ + "static/media/PLAY_MACHINES_2_Mobile.8af9cd5d.jpg";